var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.external_links.length > 0)?_c('div',_vm._l((_vm.external_links),function(item){return _c('b-button',{key:item.id,attrs:{"size":"lg","variant":item.class,"block":"","href":item.url,"target":"_blank"}},[_vm._v("\n            "+_vm._s(item.name)+"\n        ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }